import React, { useContext, useEffect, useState } from "react";
import { findOne } from "../../services/Meeting__Service";
import notifyContext from "../Context/notifyContext";
import Loader from "../Loader/Loader";

const ModalMeeting = ({ meetingId = 0, initialValue = null }) => {
  const notify = useContext(notifyContext);
  const [meeting, setMeeting] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (initialValue) {
      setMeeting({ ...initialValue });
      setIsLoading(false);
    } else if (meetingId > 0) {
      fetchOne(meetingId);
    } else {
      setMeeting(null);
    }
  }, [initialValue, meetingId]);

  const fetchOne = async (meetingId) => {
    findOne(meetingId)
      .then((response) => {
        setMeeting(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {meeting && (
        <div className="meeting-view-modal">
          <div className="infos">
            <div className="infos__item">
              <p className="label">Objet : </p>
              <p className="value">{meeting.objet}</p>
            </div>

            <div className="infos__item">
              <p className="label">Début : </p>
              <p className="value">{` ${new Date(
                meeting.dateStart
              ).toLocaleDateString("fr-Fr")} à ${meeting.timeStart} `}</p>
            </div>

            <div className="infos__item">
              <p className="label">Fin : </p>
              <p className="value">{` ${new Date(
                meeting.dateEnd
              ).toLocaleDateString("fr-Fr")} à ${meeting.timeEnd} `}</p>
            </div>

            <div className="infos__item">
              <p className="label">Lien : </p>
              <p className="value">
                {" "}
                {meeting.link ? (
                  <>
                    Cliquer{" "}
                    <strong>
                      <a href={meeting.link} target="_blank">
                        ici
                      </a>
                    </strong>{" "}
                    pour accéder à la réunion
                  </>
                ) : (
                  "pas de lien disponible."
                )}{" "}
              </p>
            </div>

            <div className="infos__item">
              <p className="label">Client : </p>
              <p className="value">{meeting.client.nom}</p>
            </div>

            <div className="infos__item">
              <p className="label">Programmée le : </p>
              <p className="value">{` ${new Date(
                meeting.dateCreate
              ).toLocaleDateString("fr-Fr")} à ${meeting.timeCreate} `}</p>
            </div>
            <div className="infos__item">
              <p className="label">Dernière modification : </p>
              <p className="value">
                {` ${new Date(meeting.dateUpdate).toLocaleDateString(
                  "fr-Fr"
                )} à ${meeting.timeUpdate} `}
              </p>
            </div>
          </div>
        </div>
      )}

      {isLoading && <Loader loadingMsg="Chargement..." />}
    </>
  );
};

export default ModalMeeting;
